<template>
  <div class="container">
    <v-card min-height="200" outlined>
      <v-card-title class="primary text-white">Generate Reports</v-card-title>
      <v-card-text class="pa-4">
        <div v-for="(button, index) in buttons" :key="index" class="mx-auto" outlined dark>
          <v-row>
            <v-col align cols="3">
              <!-- <v-tooltip bottom>
                <template #activator="{on: tooltip}">
                  <v-menu
                    v-model="button.menu"
                    :close-on-content-click="false"
                    :close-on-click="true"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    class="py-0"
                  >
                    <template v-slot:activator="{ on: menu }">
                      <v-btn
                        class="ma-3"
                        v-on="{...tooltip, ...menu}"
                        :class="button.class"
                        dark
                      >{{button.name}}</v-btn>
                    </template>
                    <v-date-picker class="mr-3" v-model="button.dates" no-title actions range>
                      <template>
                        <v-btn text color="success" @click="generateReport(button)">Generate</v-btn>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </template>
                <span>Click to generate online/offline report</span>
              </v-tooltip>-->

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ma-3"
                    :class="button.class"
                    dark
                    @click="button.menu = !button.menu"
                  >{{button.name}}</v-btn>
                </template>
                <span>{{!button.menu ? 'Open' : 'Close'}} generate report</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="button.menu">
              <v-menu
                :close-on-content-click="true"
                :close-on-click="true"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                class="py-0"
              >
                <template v-slot:activator="{on}">
                  <v-text-field label="Start Date" v-model="button.start_date" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="button.start_date"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col v-if="button.menu">
              <v-menu
                :close-on-content-click="true"
                :close-on-click="true"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                class="py-0"
              >
                <template v-slot:activator="{on}">
                  <v-text-field label="End Date" v-model="button.end_date" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="button.end_date"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2" v-if="button.menu">
              <v-btn
                color="success"
                class="mt-5"
                text
                @click="generateReport(button)"
                :disabled="!(button.start_date && button.end_date)"
              >Generate</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="mt-8" v-if="recentReports.length">
      <v-card-title class="primary text-white">Recently generated reports</v-card-title>
      <v-card-text>
        <v-data-table :headers="reportListsHeader" :items="recentReports">
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" @click="viewReport(item)">remove_red_eye</v-icon>
              </template>
              <span>View Report</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="reportDialog" :width="1000" scrollable>
      <v-card>
        <v-card-title class="primary text-white">
          Report
          <v-spacer></v-spacer>
          <v-icon @click="reportDialog = false" dark>close</v-icon>
        </v-card-title>
        <v-card-text class="mt-4 pb-0">
          <v-data-table :headers="reportHeaders" :items="selectedReport.details"></v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="success" @click="generateCSV(selectedReport,selectedReport.details)" text>Download</v-btn> -->
            <v-btn color="error" @click="reportDialog = false" text>Close</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

function initialState () {
  return {
    buttons: [
      {
        name: 'Online / Offline',
        menu: false,
        class: 'primary lighten-1',
        dates: [],
        start_date: '',
        end_date: ''
      }
    ],
    reportListsHeader: [
      { text: 'Type', value: 'name' },
      { text: 'Start Date', value: 'start_date' },
      { text: 'End Date', value: 'end_date' },
      { text: 'Generated on', value: 'generated_at' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    reportHeaders: [
      { text: 'Name', value: 'device_name' },
      { text: 'Offline seconds', value: 'offline_seconds' },
      { text: 'Offline Minutes', value: 'offline_minutes' },
      { text: 'Offline hours', value: 'offline_hours' },
      { text: 'Offline days', value: 'offline_days' },
      { text: 'Online_offline_count', value: 'online_offline_count' },
      { text: 'Currently Online', value: 'current_status' }
    ],
    reportDialog: false,
    selectedReport: {}
  }
}
export default {
  data () {
    return initialState()
  },

  async mounted () {},

  methods: {
    generateReport (type) {
      if (type.name === 'Online / Offline') {
        this.generateOnlineOfflineReport(type)
      }
    },

    async generateOnlineOfflineReport (data) {
      this.spinner(true)
      let params = {
        start_date: data.start_date,
        end_date: data.end_date,
        summary: true
      }
      try {
        this.snackbar({ text: 'Generating report' })
        await this.$store.dispatch('signage/GetDevicesStatusLogs', params)
        await this.generateCSV(params, this.reports)
        this.setRecentlyAddedReport(data)
        // this.buttons[0].menu = false
        this.resetAll()
        this.snackbar({ text: 'Report Generated' })
      } catch (error) {
        this.snackbar({ text: error.response.data.msg })
      }
      this.spinner(false)
    },

    generateCSV (params, value) {
      // map according to  desired keys
      let data = value.map(el => ({
        device_name: el.device_name,
        offline_seconds: el.offline_seconds,
        offline_minutes: el.offline_minutes,
        offline_hours: el.offline_hours,
        offline_days: el.offline_days,
        online_offline_count: el.online_offline_count,
        currently_online: el.current_status
      }))
      const csvRows = []

      // get the headers
      const headers = Object.keys(data[0])
      csvRows.push(headers.join(','))

      // loop over the rows
      for (const row of data) {
        const values = headers.map(header => {
          const escaped = ('' + row[header]).replace(/"/g, '\\"')
          return `"${escaped}"`
        })
        csvRows.push(values.join(','))
      }
      const csv = csvRows.join('\r\n')
      this.download(csv, params)
    },
    // download csv
    download (data, params) {
      const blob = new Blob([data], { type: 'text/csv' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('hidden', '')
      a.setAttribute('href', url)
      a.setAttribute(
        'download',
        `Report_${params.start_date}_${params.end_date}`
      )
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    setRecentlyAddedReport (data) {
      let report = [
        ...this.recentReports,
        {
          name: data.name,
          start_date: data.start_date,
          end_date: data.end_date,
          generated_at: moment().format('YYYY-MM-DD @ hh:mm:ss a'),
          details: this.reports
        }
      ]
      try {
        this.$store.commit('signage/SET_RECENTLY_GENERATED_REPORTS', report)
      } catch (e) {
        this.snackbar({ text: e.response.data.msg })
      }
    },

    viewReport (report) {
      this.reportDialog = true
      this.selectedReport = report
    },

    resetAll () {
      Object.assign(this.$data, initialState())
    }
  },

  computed: {
    ...mapGetters({
      reports: 'signage/devicesStatusLogs',
      recentReports: 'signage/recentReports'
    })
  }
}
</script>

<style>
</style>
